import {
	Hallmap,
	selectHallmapLoader,
	selectHallmapSelectedTables,
	selectResourcesState,
} from 'entities/hallmap';
import { FC, useEffect, useState } from 'react';
import { Game } from 'shared/lib/core';
import { HallmapWrapper } from './styles';
import { TMode } from 'entities/hallmap';
import { PlacesNavigation } from 'entities/toolbar/places';
import { useAppDispatch, useAppSelector } from 'shared/lib/store';
import { selectOrderForBooking, updateBookingResources } from 'entities/orders';
import { Overlay } from 'shared/ui/modal/styles';
import { Preloader } from 'shared/ui/spinner';

interface HallmapTablesProps {
	hallmapId?: string;
	hallmapContainerId?: string;
	mode?: TMode;
	height?: number;
}

export const HallmapManager: FC<HallmapTablesProps> = ({
	hallmapId = 'hallmap',
	hallmapContainerId = 'hallmap-container',
	mode = 'static',
}) => {
	const [hallmap, setHallmap] = useState<Game | undefined>();
	const order = useAppSelector(selectOrderForBooking);

	const selectedResources = useAppSelector(selectHallmapSelectedTables);
	const resourcesState = useAppSelector(selectResourcesState);
	const dispatch = useAppDispatch();
	const isLoading = useAppSelector(selectHallmapLoader);

	useEffect(() => {
		if (selectedResources.length) {
			const resources = selectedResources.map(resource => resource.id);
			dispatch(updateBookingResources({ resources }));
		}
	}, [selectedResources, dispatch]);

	return (
		<HallmapWrapper id={hallmapContainerId}>
			<Overlay $isOpen={isLoading} $background="#b4bfcb4f" $zIndex={2}>
				{isLoading && <Preloader />}
			</Overlay>
			<PlacesNavigation hallmap={hallmap} />
			{(mode === 'static' ? resourcesState.length > 0 : true) && (
				<Hallmap
					setHallmap={setHallmap}
					id={hallmapId}
					containerId={hallmapContainerId}
					mode={mode}
					order={order}
				/>
			)}
		</HallmapWrapper>
	);
};
